/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_ReservedInputs */

const en_onboarding_v1_username_reserved = /** @type {(inputs: Onboarding_V1_Username_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That username is reserved.`)
};

const de_onboarding_v1_username_reserved = /** @type {(inputs: Onboarding_V1_Username_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Benutzername ist reserviert.`)
};

const pt_br2_onboarding_v1_username_reserved = /** @type {(inputs: Onboarding_V1_Username_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse nome de usuário está reservado.`)
};

const tr_onboarding_v1_username_reserved = /** @type {(inputs: Onboarding_V1_Username_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kullanıcı adı ayrılmıştır.`)
};

const zh_cn2_onboarding_v1_username_reserved = /** @type {(inputs: Onboarding_V1_Username_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此用户名已被保留。`)
};

const zh_hk2_onboarding_v1_username_reserved = /** @type {(inputs: Onboarding_V1_Username_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此用戶名稱已被保留。`)
};

const ko_kr2_onboarding_v1_username_reserved = /** @type {(inputs: Onboarding_V1_Username_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 사용자 이름은 예약되어 있습니다.`)
};

const ru_ru2_onboarding_v1_username_reserved = /** @type {(inputs: Onboarding_V1_Username_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это имя пользователя зарезервировано.`)
};

const es_419_onboarding_v1_username_reserved = /** @type {(inputs: Onboarding_V1_Username_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese nombre de usuario está reservado.`)
};

/**
* | output |
* | --- |
* | "That username is reserved." |
*
* @param {Onboarding_V1_Username_ReservedInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_reserved = /** @type {((inputs?: Onboarding_V1_Username_ReservedInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_ReservedInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_reserved(inputs)
	if (locale === "de") return de_onboarding_v1_username_reserved(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_reserved(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_reserved(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_reserved(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_reserved(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_reserved(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_reserved(inputs)
	return es_419_onboarding_v1_username_reserved(inputs)
});